import gql from "graphql-tag";
const queryByOwnerType = gql(` 
query queryByOwnerTypeIndex($owner: String!, $type: String, $nextToken: String) {
  queryByOwnerTypeIndex(owner: $owner, type: $type, nextToken: $nextToken) {
      items{group customgroup sample alias origin v2 outlier geo SSE ethnicity age description coords coords2 simulated vendor object bucket type public download entityType}
      nextToken
  } 
}   
`)
export default queryByOwnerType;
